import { TemplatesApi } from '../../../api/templatesApi';
import { DialogProps } from '../../../interfaces/Templates';
import withSnackbar from '../../../shared/components/withSnackbar';
import { SovosDialog, SovosDialogTitle, SovosDialogContent, SovosDialogActions, SovosButton } from 'mosaic-react';
import React, { useState } from 'react';

const DeleteTemplateDialog: React.FC<DialogProps> = (props: DialogProps) => {
	const { isDialogOpen, setIsDialogOpen, template, snackbarData } = props;
	const [isDeleting, setIsDeleting] = useState<boolean>(false);

	const handleClose = (): void => {
		if (!isDeleting) {
			setIsDialogOpen(false);
		}
	};

	const handleDelete = (): void => {
		if (isDialogOpen) {
			setIsDeleting(true);
			const selectedTemplateId = template.id;
			TemplatesApi.deleteTemplate(selectedTemplateId)
				.then(response => {
					if (response.data.status === 200) {
						setIsDialogOpen(false);
						snackbarData({ message: `${template.name} has been deleted!`, variant: 'confirmation', open: true });
						setIsDeleting(false);
					}
				})
				.catch(error => {
					console.error('Error: ', error);
					setIsDeleting(false);
				});
		}
	};

	return (
		<SovosDialog open={isDialogOpen} onClose={handleClose}>
			<SovosDialogTitle>Delete this template?</SovosDialogTitle>
			<SovosDialogContent>
				<p>
					You will no longer be able to use this template when importing transaction data. This action cannot be undone.
				</p>
			</SovosDialogContent>

			<SovosDialogActions>
				<SovosButton variant='text' onClick={handleClose} disabled={isDeleting}>
					Cancel
				</SovosButton>
				<SovosButton variant='text' color='error' onClick={handleDelete} disabled={isDeleting}>
					Delete Template
				</SovosButton>
			</SovosDialogActions>
		</SovosDialog>
	);
};

export default withSnackbar(DeleteTemplateDialog);
